module.exports = __webpack_public_path__ + "static/img/4392_phase_function_Paper_PointsHejduk_Prediction.2d794e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4392_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Quk1
// module chunks = 0